import { Card, CardContent, Typography, Box, Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";

function StatusCard({ quantity, name, icon, color = "#1976d2", status }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/agreements?status=${status}&page=1`);
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        display: "flex",
        alignItems: "center",
        p: 2,
        borderRadius: 2,
        cursor: "pointer",
        boxShadow: 2,
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "scale(1.02)",
          boxShadow: 4,
        },
      }}
    >
      <Avatar sx={{ bgcolor: color, mr: 2 }}>{icon}</Avatar>
      <Box>
        <Typography variant="subtitle2" color="textSecondary">
          {name}
        </Typography>
        <Typography variant="h6" fontWeight="bold" color={color}>
          {quantity}
        </Typography>
      </Box>
    </Card>
  );
}

export default StatusCard;
